import React from "react";
import Hero from "./Hero";
import HotBid from "../../components/HotBid";

const Faq = () => {
  return (
    <>
    {/* this is sample page */}
      <Hero />
      {/* <HotBid classSection="section-pb" /> */}
    </>
  );
};

export default Faq;
